module.exports = __webpack_public_path__ + "static/media/china.4e4d59b7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/image/flag/china.svg
// module id = 1205
// module chunks = 39